import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import Topbar from './topbar/Topbar';
import Sidebar from './sidebar/Sidebar';

import {changeThemeToDark, changeThemeToLight} from '../../redux/actions/themeActions';
import {changeMobileSidebarVisibility, changeSidebarVisibility} from '../../redux/actions/sidebarActions';
import {SidebarProps} from '../../shared/prop-types/ReducerProps';
import TopbarLine from "./topbar/TopbarLine";

class Layout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFirst: true
        }
    }

    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        sidebar: SidebarProps.isRequired,
    };

    changeSidebarVisibility = () => {
        this.props.dispatch(changeSidebarVisibility());
    };

    changeMobileSidebarVisibility = () => {
        this.props.dispatch(changeMobileSidebarVisibility());
    };

    changeToDark = () => {
        this.props.dispatch(changeThemeToDark());
    };

    changeToLight = () => {
        this.props.dispatch(changeThemeToLight());
    };

    render() {
        let showNumber = false;
        let isScreen = false;
        if(this.props.userData.data) {
            showNumber = this.props.userData.data.userType !== 5 && this.props.userData.data.userType !== 6;
            isScreen = this.props.userData.data.is_screen;
        }

        if(isScreen && this.state.isFirst) {
            this.changeSidebarVisibility();
            this.changeMobileSidebarVisibility();

            this.setState({isFirst: false});
        }
        return (
            <div>
                <TopbarLine/>
                <Topbar
                    isScreen={isScreen}
                    showNumber={showNumber}
                    changeMobileSidebarVisibility={this.changeMobileSidebarVisibility}
                    changeSidebarVisibility={this.changeSidebarVisibility}
                />
                {!isScreen && <Sidebar
                    sidebar={this.props.sidebar}
                    changeToDark={this.changeToDark}
                    changeToLight={this.changeToLight}
                    changeMobileSidebarVisibility={this.changeMobileSidebarVisibility}
                />}
            </div>
        );
    }
}

export default withRouter(connect(state => ({
    sidebar: state.sidebar,
    userData: state.userData
}))(Layout));
